import { API_ROOT_URL } from "../config";
import { handleResponse } from "../helpers";

export const WhitelabelService = {
  fetchWhitelabel,
};

function fetchWhitelabel() {
    const override = process.env.REACT_APP_WHITELABEL_SUBDOMAIN;
    const hostname = window.location.hostname;
    const sub_domain = override || hostname.split('.')[0];
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      }
    };
    return fetch(`${API_ROOT_URL}/projects/?q=${sub_domain}`, requestOptions).then(response => handleResponse(response))
		.then(data => {
			return data;
		});
  }


// WEBPACK FOOTER //
// ./src/services/whitelabel.service.js